import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteWithdrawal,
  fetchWithdrawals,
  setWithdrawalParams,
  updateWithdrawal,
} from "../../redux/withdrawals.ts";
import { debounce } from "lodash";
import { Pagination } from "../../components/pagination/index.js";
import DeleteModal from "../../components/deleteModal/index.js";
import { CrudTable } from "../../components/table/crudTable.jsx";
import { Breadcrumbs } from "../../components/breadcrumbs/index.jsx";

export const Withdrawals = () => {
  const dispatch = useDispatch();
  const {
    withdrawalList = { data: [] },
    isLoading,
    withdrawalParam,
  } = useSelector((store) => store.withdrawal || {});
  const [param, setParam] = useState(withdrawalParam || { first: 12, page: 1 });
  const [id, setId] = useState();
  const [isMounted, setIsMounted] = useState(false);
  const popupRef = useRef();

  useEffect(() => {
    if (isMounted) {
      dispatch(fetchWithdrawals({ param: { ...param, page: 1 } }));
      dispatch(setWithdrawalParams({ ...param, page: 1 }));
    } else {
      setIsMounted(true);
    }
  }, [param?.user]);

  useEffect(() => {
    dispatch(fetchWithdrawals({ param }));
  }, []);

  const handlePage = (page) => {
    dispatch(fetchWithdrawals({ param: { ...param, page } }));
    dispatch(setWithdrawalParams({ ...param, page }));
  };

  const setUser = debounce((value) => {
    setParam({ ...param, user: value });
  }, 1000);

  const handleDelete = (id) => {
    setId(id);
    popupRef?.current?.open({
      id,
      deleteFun: deleteWithdrawal,
      type: "Withdrawal",
    });
  };

  const tableData = [
    {
      key: "User Username",
      value: "user.username",
      edit: false,
      type: "text",
    },
    { key: "User Email", value: "user.email", edit: false, type: "text" },
    { key: "Amount", value: "amount", edit: false, type: "number" },
    {
      key: "Payment Method",
      value: "payment_method",
      edit: false,
      type: "text",
    },
    { key: "Bank Name", value: "bank_name", edit: false, type: "text" },
    { key: "Account Number", value: "account_number", edit: false },
    { key: "Swift Code", value: "swift_code", edit: false },
    { key: "Paypal Email", value: "paypal_email", edit: false },
    { key: "Crypto Wallet", value: "crypto_wallet", edit: false },
    { key: "Crypto Network", value: "crypto_network", edit: false },
    { key: "WhatsApp", value: "whatsapp", edit: false },
    { key: "WeChat", value: "wechat", edit: false },
    { key: "Telegram", value: "telegram", edit: false },
    {
      key: "Transaction Reference",
      value: "transaction_reference",
      edit: true,
    },
    {
      key: "Status",
      value: "status",
      type: "status",
      edit: true,
      options: ["pending", "processing", "completed", "rejected", "cancelled"],
    },
    {
      key: "Admin Comment",
      value: "admin_comment",
      edit: true,
      type: "textarea",
    },
    { key: "Created At", value: "created_at", type: "date", edit: false },
  ];

  const actions = [
    {
      type: "delete",
      func: handleDelete,
      isLoading: isLoading?.deleteWithdrawal,
    },
  ];

  const handleUpdate = async (id, data) => {
    const success = await dispatch(updateWithdrawal(id, data));
    return success;
  };

  return (
    <>
      <Breadcrumbs breadcrumbs={[{ name: "Withdrawals", link: "" }]} />
      <div className="relative lg:px-12 px-3">
        <DeleteModal ref={popupRef} />
        <div className="flex justify-start items-center gap-x-10 my-2">
          <div className="flex flex-col">
            <label className="font-light">User</label>
            <input
              onChange={(e) => {
                const inputValue = e.target.value;
                setUser.cancel();
                setUser(inputValue);
              }}
              defaultValue={withdrawalParam?.user}
              className="bg-transparent border border-gray-300 text-gray-900 sm:text-sm rounded-lg outline-none focus:border-orange-600 block w-full p-2.5"
            />
          </div>
        </div>
        <div className="lg:h-[calc(100vh-270px)] overflow-auto hide-scroll">
          <CrudTable
            data={tableData}
            table={withdrawalList.data || []}
            actions={actions}
            id={id}
            isLoading={isLoading?.withdrawals}
            onUpdate={handleUpdate}
          />
        </div>
        <Pagination
          total={withdrawalList.last_page}
          current={withdrawalList.current_page}
          func={handlePage}
        />
      </div>
    </>
  );
};
